import { useQuery } from '@tanstack/react-query';
import { useTramaClient } from '../context.js';
import type { TramaCollection } from 'trama-types';

export function useCollections() {
  const client = useTramaClient();

  return useQuery({
    queryKey: ['collections'],
    queryFn: () => client.request<TramaCollection[]>('/api/v1/collections'),
  });
}
